/**
 * @file index.tsx
 *
 * @fileoverview Renders button with a link to Attachment (field_job_attachment) in case of Job per template
 *   attachment module is enabled and field filled.
 */

import React from 'react';
import { Job } from '~/jobiqo/types/types';
import { FormattedMessage } from 'react-intl';
import OriginalAdButton from '~/jobiqo/components/Job/Detail/components/OriginalAdButton';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { AlignedCenter } from '~/vcl/atoms/06-layout/01-alignment/01-align-center';

interface JobDetailAttachmentButtonProps {
  /**
   * The job.
   */
  job: Job;
}

export const JobDetailAttachmentButton = ({
  job,
}: JobDetailAttachmentButtonProps) => {
  return job['attachmentUrl'] ? (
    <>
      <Spacing marginTop={8} />
      <AlignedCenter>
        <OriginalAdButton
          job={job}
          src={job['attachmentUrl']}
          customButtonText={
            <FormattedMessage
              id="job_detail_attachment_button"
              defaultMessage="Show job attachment"
            />
          }
        />
      </AlignedCenter>
    </>
  ) : null;
};

export default JobDetailAttachmentButton;
